import { useContext } from 'react';
import { ICurrentRegisteredPersonContext, CurrentRegisteredPersonContext } from '../contexts';

export const useCurrentRegisteredPerson = (): ICurrentRegisteredPersonContext => {
  const context = useContext(CurrentRegisteredPersonContext);

  return context;
};
